import Resource from '@/api/resources/Resource'

class JobResponsibilityConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/jobResponsibilities`, filterModel, { params })
        return response.data
    }
    async getJobResponsibilitiesByJobCode(jobCode) {
        const response = await this.axios.get(`/configuration/jobs/${jobCode}/jobResponsibilities`)
        return response.data
    }
    async createJobResponsibility(jobResponsibilityCreateRequest) {
        const response = await this.axios.post(`/configuration/jobResponsibilities`, jobResponsibilityCreateRequest)
        return response.data
    }
    async deleteJobResponsibility(jobResponsibilityId) {
        const response = await this.axios.delete(`/configuration/jobResponsibilities/${jobResponsibilityId}`)
        return response.data
    }
}

export default new JobResponsibilityConfigurationServices()
